import React from "react";
import OrdersPage from "Common/Components/OrdersPage";

// سفارش‌های در حال تولید = سفارش‌هایی که order_status آن‌ها in_production است.
// طبق مستند این وضعیت را سرور از روی وضعیت قلم‌ها محاسبه می‌کند (کافی است حداقل یک
// قلم در حال تولید باشد)، بنابراین هیچ دکمه‌ای برای تغییر مستقیم وضعیت سفارش وجود ندارد.
const Index = () => (
  <OrdersPage
    pageTitle="سفارش‌های در حال تولید"
    orderStatus="in_production"
    emptyText="هیچ سفارشی در حال تولید نیست"
  />
);

export default Index;
